var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoBattery0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "symbol",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,6 C18.6569,6 20,7.34315 20,9 L20,10 L21.0003237,10 C21.1824237,10 21.3532237,10.0487 21.5003237,10.1338 C21.7992237,10.3067 22.0003237,10.6299 22.0003237,11 L22.0003237,13 C22.0003237,13.3701 21.7992237,13.6933 21.5003237,13.8662 C21.3532237,13.9513 21.1824237,14 21.0003237,14 L20,14 L20,15 C20,16.6569 18.6569,18 17,18 L4.99967629,18 C3.34282629,18 1.99967629,16.6569 1.99967629,15 L1.99967629,9 C1.99967629,7.34315 3.34282629,6 4.99967629,6 L17,6 Z M16.998153,7.5 L4.99967629,7.5 C4.21997746,7.5 3.57922729,8.09488554 3.50654284,8.85553954 L3.49967629,9 L3.49967629,15 C3.49967629,15.7796706 4.09456182,16.4204457 4.85521583,16.4931332 L4.99967629,16.5 L16.998153,16.5 C17.7778236,16.5 18.4185987,15.9050879 18.4912862,15.1444558 L18.498153,15 L18.498153,9 C18.498153,8.22030118 17.9032409,7.579551 17.1426088,7.50686655 L16.998153,7.5 Z",
    id: "\\uD83C\\uDFA8-Color"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBattery0);
export default __webpack_public_path__ + "static/media/ico-battery-0.4c8cfb85.svg";
export { ForwardRef as ReactComponent };